<app-teledeteccion-container (areaCreated)="onAreaCreated($event)">
  <div class="tele-top-overlays">
    <div class="tele-panel-actions">
      <div class="tele-search-and-filters">
        <app-buscador-autocomplete
          class="map-search"
          [formControl]="searchTerm"
          (selectedItem)="onAreaSelected($event)"
          [data]="searchAreas()"></app-buscador-autocomplete>
        <app-chips-container id="chips-area">
          <app-selector-chip
            #indicesChip
            [data]="indicesVegetacion"
            [tooltips]="indiceTooltipText"
            label="Seleccione índice"
            selectedLabelPrefix="Índice: "
            [disabledInput]="showMenuComparacion()"
            [formControl]="
              primaryFilterFormGroup().controls['indice']
            "></app-selector-chip>
          <app-selector-datepicker
            #datepickerChip
            [disabled]="showMenuComparacion()"
            [formControl]="primaryFilterFormGroup().controls['fecha']">
          </app-selector-datepicker>
          <app-selector-chip
            #escalaChip
            [data]="escalas"
            [unselectOption]="false"
            selectedIndex="0"
            label="Seleccione escala"
            [disabledInput]="showMenuComparacion() || isVisibleIndexSelected"
            [formControl]="
              primaryFilterFormGroup().controls['escala']
            "></app-selector-chip>
          <app-chips-map-buttons
            #imageBlurChip
            [isSelected]="imageBlur()"
            (clicked)="onImageBlurClick($event)"
            chipLabel="Imagen suavizada"
            [disabled]="isVisibleIndexSelected"
            chipIcon="blur_on"></app-chips-map-buttons>
          <app-chips-map-buttons
            #comparacionChip
            [ariaDescription]="'Modo Comparación'"
            (clicked)="onModoComparationClick($event)"
            chipIcon="split_scene"
            [isSelected]="showMenuComparacion()"
            [chipLabel]="
              showMenuComparacion()
                ? 'Cerrar Modo Comparación'
                : 'Dividir pantalla'
            "></app-chips-map-buttons>
          <app-chips-map-buttons
            [ariaDescription]="'Crear área'"
            (clicked)="onCreateAreaClick($event)"
            [isSelected]="isDrawing()"
            chipIcon="add"
            chipLabel="Crear área"></app-chips-map-buttons>
        </app-chips-container>
      </div>

      @if (showMenuComparacion()) {
        <div class="tele-menu-compare">
          <app-tele-menu-comparacion
            #menuComparacion
            [leftFormGroup]="leftFilterFormGroup()"
            [rightFormGroup]="rightFilterFormGroup()"
            [indiceTooltips]="indiceTooltipText"
            (changeLeftForm)="onChangeLeftForm($event)"
            (changeRightForm)="onChangeRightForm($event)"
            (clickCloseButton)="onClickCloseMenuComparacion($event)">
          </app-tele-menu-comparacion>
        </div>
      }
      @if (!selectedArea()) {
        <div class="tele-area-select-text-chip-container">
          <div class="tele-area-select-text-chip">
            <span class="material-symbols-rounded">info</span>
            <span class="textos-body-medium"
              >Selecciona un área para ver el índice y la fecha filtrada</span
            >
          </div>
        </div>
      }
    </div>

    @if (selectedArea() && showAreaInfo()) {
      <ng-template #dateInfoTooltip>
        <div class="tele-date-tooltip textos-body-small">
          {{ dateInfoTooltipText }}
        </div>
      </ng-template>
      <ng-template #indicesDefinitionTooltip>
        <div class="tele-indices-tooltip">
          <div class="tooltip-section">
            <div class="tooltip-section-title textos-body-medium">
              Definición índices
            </div>
            <ul class="tooltip-list textos-body-small">
              <li>
                <strong>Imagen Real:</strong> {{ indiceTooltipText.VISIBLE }}
              </li>
              <li><strong>NDVI:</strong> {{ indiceTooltipText.NDVI }}</li>
              <li><strong>GNDVI:</strong> {{ indiceTooltipText.GNDVI }}</li>
              <li><strong>NDRE:</strong> {{ indiceTooltipText.NDRE }}</li>
              <li><strong>EVI:</strong> {{ indiceTooltipText.EVI }}</li>
              <li><strong>MSAVI:</strong> {{ indiceTooltipText.MSAVI }}</li>
              <li><strong>ReCI:</strong> {{ indiceTooltipText.ReCI }}</li>
              <li><strong>NDMI:</strong> {{ indiceTooltipText.NDMI }}</li>
              <li><strong>NDWI:</strong> {{ indiceTooltipText.NDWI }}</li>
            </ul>
          </div>
        </div>
      </ng-template>
      <div
        class="tele-selected-area-info-container"
        [ngClass]="{
          'opened-modo-comparacion': showMenuComparacion(),
          'with-historic-open': showHistoricChart(),
        }">
        <app-collapsible-popup-shell
          [title]="selectedArea().name"
          [expanded]="areaInfoExpanded()"
          (expandedChange)="areaInfoExpanded.set($event)"
          (close)="onCloseAreaInfo()">
          <div class="tele-selected-area-info-content">
            <div class="tele-info-cultivo-container">
              <div class="tele-info-cultivo-text">
                Información extra:
                @if (selectedArea().comment) {
                  <br />{{ selectedArea().comment }}
                }
                <br />
                @if (selectedArea().crop) {
                  <br />Cultivo: {{ selectedArea().crop | titlecase }}
                }
              </div>
            </div>
            @if (isComparisonMode() && hasActiveOverlaysInComparison()) {
              <!-- Modo comparación: mostrar dos fechas -->
              @if (getPlottedImageDateLeft()) {
                <span class="tele-info-fecha-graficada">
                  <span class="tele-info-fecha-text">
                    Fecha graficada pantalla izquierda:
                    {{ getPlottedImageDateLeft() | date: 'dd/MM/yyyy' }}
                  </span>
                  <span
                    class="material-symbols-rounded tele-info-fecha-icon"
                    [appTooltip]="dateInfoTooltip"
                    tooltipPosition="top"
                    >info</span
                  >
                </span>
              }
              @if (getPlottedImageDateRight()) {
                <span class="tele-info-fecha-graficada">
                  <span class="tele-info-fecha-text">
                    Fecha graficada pantalla derecha:
                    {{ getPlottedImageDateRight() | date: 'dd/MM/yyyy' }}
                  </span>
                  <span
                    class="material-symbols-rounded tele-info-fecha-icon"
                    [appTooltip]="dateInfoTooltip"
                    tooltipPosition="top"
                    >info</span
                  >
                </span>
              }
            } @else if (getPlottedImageDate()) {
              <!-- Modo normal: mostrar una sola fecha -->
              <span class="tele-info-fecha-graficada">
                <span class="tele-info-fecha-text">
                  Fecha graficada:
                  {{ getPlottedImageDate() | date: 'dd/MM/yyyy' }}
                </span>
                <span
                  class="material-symbols-rounded tele-info-fecha-icon"
                  [appTooltip]="dateInfoTooltip"
                  tooltipPosition="top"
                  >info</span
                >
              </span>
            }

            <!-- Histórico índice -->
            <div class="tele-historic-chart-container">
              @if (!isVisibleIndexSelected) {
                <div
                  class="historic-toggle-row"
                  (click)="onClickShowHistoric()">
                  <span class="material-symbols-rounded historic-icon"
                    >monitoring</span
                  >
                  <span class="text-link" role="button">
                    {{
                      showHistoricChart() && historicChartData().datasets.length
                        ? 'Cerrar histórico'
                        : 'Ver histórico'
                    }}
                  </span>
                </div>
              }
              @if (showHistoricChart()) {
                <div class="historic-chart-wrapper">
                  <div class="historic-header textos-body-medium">
                    Histórico índice {{ getSelectedIndiceName?.() || '' }}
                  </div>
                  <div class="historic-description textos-body-small">
                    Selecciona la métrica a calcular para los últimos 3 meses de
                    este año y el mismo periodo el año pasado
                  </div>
                  <div class="historic-metric-selector">
                    <div class="metric-options">
                      <mat-radio-group
                        aria-label="Seleccione una opcion"
                        value="median">
                        <mat-radio-button
                          class="textos-body-small"
                          value="median"
                          color="primary"
                          (change)="onHistoricMetricChange('median')"
                          >Mediana</mat-radio-button
                        >
                        <mat-radio-button
                          class="textos-body-small"
                          value="mean"
                          color="primary"
                          (change)="onHistoricMetricChange('mean')"
                          >Promedio</mat-radio-button
                        >
                        <mat-radio-button
                          class="textos-body-small"
                          value="min"
                          color="primary"
                          (change)="onHistoricMetricChange('min')"
                          >Mínimo</mat-radio-button
                        >
                        <mat-radio-button
                          class="textos-body-small"
                          value="max"
                          color="primary"
                          (change)="onHistoricMetricChange('max')"
                          >Máximo</mat-radio-button
                        >
                      </mat-radio-group>
                    </div>
                  </div>
                  @if (loadingHistoric()) {
                    <div class="historic-loading">
                      <app-load-spinner> </app-load-spinner>
                    </div>
                  } @else if (historicError()) {
                    <div class="historic-error">{{ historicError() }}</div>
                  } @else if (historicChartData().datasets.length) {
                    <div class="historic-chart-box">
                      <app-line-chart
                        [chartData]="historicChartData()"
                        [colorLine1]="historicColors.current"
                        [colorLine2]="historicColors.previous"
                        [titleYaxis]="historicYAxisTitle()"
                        [yMin]="historicYMin()"
                        [yMax]="historicYMax()"
                        [gridOption]="'horizontal'"
                        [unit]="''"
                        [xLabelMode]="'week'"
                        [canvasHeight]="220"
                        [noPadding]="true"
                        [tickFontSize]="10"
                        [enableDecimation]="false"></app-line-chart>
                    </div>

                    <!-- <div class="historic-legend-help textos-body-small">
                    Comparativa últimos 3 meses vs mismo periodo del año anterior.
                  </div> -->
                  }
                </div>
              }
            </div>
            <div
              class="tele-indices-definition-container textos-label-large"
              [appTooltip]="indicesDefinitionTooltip">
              <span class="material-symbols-rounded definition-icon">info</span>
              <span class="text-link">Definición índices</span>
            </div>
            <div class="tele-selected-area-delete-container">
              <span
                class="tele-selected-area-delete-button textos-label-large"
                (click)="onDeleteSelectedArea(selectedArea().id)">
                <span class="material-symbols-rounded">delete</span>
                <span class="text-link"> Eliminar área</span>
              </span>
            </div>
          </div>
        </app-collapsible-popup-shell>
      </div>
    }
  </div>

  <div
    id="map"
    #map
    leaflet
    leafletDraw
    [leafletDrawOptions]="drawOptions"
    (leafletDrawCreated)="onDrawCreated($event)"
    (leafletDrawReady)="onDrawReady($event)"
    [leafletOptions]="options()"
    (leafletMouseMove)="leafletMouseMove($event)"
    (leafletMapReady)="onMapReady($event)">
    <div [leafletLayer]="drawnItems"></div>
  </div>

  @if (showScale() && !shouldHideScale('left')) {
    <div class="scale-bottom left">
      <app-colored-scale
        [title]="getCurrentScaleTitle('left')"
        [min]="getCurrentScaleMin('left')"
        [max]="getCurrentScaleMax('left')"
        [ticks]="8"
        [colorRamp]="getCurrentColorRamp('left')"
        [disabled]="isScaleDisabled('left')">
      </app-colored-scale>
    </div>
    @if (showSecondScale() && !shouldHideScale('right')) {
      <div class="scale-bottom right">
        <app-colored-scale
          [title]="getCurrentScaleTitle('right')"
          [min]="getCurrentScaleMin('right')"
          [max]="getCurrentScaleMax('right')"
          [ticks]="8"
          [colorRamp]="getCurrentColorRamp('right')"
          [disabled]="isScaleDisabled('right')">
        </app-colored-scale>
      </div>
    }
  }

  <div class="tele-gps-chip-container">
    @if (showBottomMessage()) {
      <div id="bottomMessage" class="gis-bottom-message">
        <span class="material-symbols-rounded">info</span>
        <span class="textos-body-medium error-bottom-message">
          {{ bottomMessage() }}
        </span>
      </div>
    }

    <div [style.display]="showGpsIndicator() ? 'flex' : 'none'">
      <div class="gps">
        <app-gps-indicator [latitude]="lat()" [longitude]="long()">
        </app-gps-indicator>
      </div>
    </div>
  </div>
</app-teledeteccion-container>
